export default __webpack_public_path__ + "static/1215-7c5c4eba9684244138f9593b4392fff3.gif";